<script setup>

    import whmcs_white from '@/assets/img/integrations/whmcs_logo_navy_green.png';
    import whmcs_dark from '@/assets/img/integrations/whmcs_logo_white_green.png';
    import axios from 'axios';
    import { computed } from 'vue';
    import { onBeforeMount } from 'vue';
    import { useStore } from 'vuex';

    const store = useStore();
    const darkMode = computed(() => store.state.darkMode);

    onBeforeMount(() => {

        store.state.integrations = [];

        get_instegrations();

    });

   

    const get_instegrations = () => {

        axios.get('integrations')
        .then(res => {
            store.state.integrations = res.data
        })
        .catch(err => {
            console.error(err); 
        })

    };

</script>

<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 mt-3 mb-4">
                <h4>Selecione sua integração</h4>
            </div>
            
            <div class="col-3 rounded-5" :class="!darkMode ? 'bg-white' : 'bg-222222'">
                <div class="row pt-4 pb-2">
                    <div class="col-6">
                        <img :src="!darkMode ? whmcs_white : whmcs_dark" alt="" class="img-fluid">
                    </div>
                    <div class="col-6">
                        <router-link 
                            class="btn btn-sm"
                            to="/configuracoes/integracoes/whmcs"
                            v-bind:class="{
                                'btn-success': store.state.integrations.indexOf('whmcs') == -1,
                                'btn-dark': store.state.integrations.indexOf('whmcs') > -1
                            }"
                        >
                            {{store.state.integrations.indexOf('whmcs') == -1 ? 'Ativar' : 'Editar'}}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>